// Spanish translations
const es = {
  // Navigation
  nav: {
    prayerRequest: "Solicitud de Oración",
    sacredSites: "Lugares Sagrados",
    prayerWall: "Muro de Oración",
    testimonials: "Testimonios",
    holyWord: "Palabra Santa",
    pricing: "Precios",
    login: "Iniciar Sesión",
    signup: "Registrarse",
    dashboard: "Panel",
    admin: "Admin",
    logout: "Cerrar Sesión"
  },
  
  // Home page
  home: {
    badge: "Conectando Corazones con Tierra Santa",
    title: "Conecta Tu Corazón con la",
    titleHighlight: "Tierra Sagrada",
    subtitle: "Tus oraciones más profundas merecen un viaje sagrado. Entregamos personalmente tus intenciones a los lugares más santos de Jerusalén, ofreciéndolas con reverencia, y enviándote una fotografía conmemorativa.",
    cta: "Comienza Tu Viaje de Oración",
    discoverSites: "Descubre Lugares Sagrados",
    prayerFor: "Oración por",
    family: "Familia",
    health: "Salud",
    peace: "Paz",
    howItWorks: "Cómo Funciona",
    howItWorksSubtitle: "Un viaje sagrado en tres simples pasos",
    step1Title: "Escribe Tu Oración",
    step1Desc: "Comparte lo que hay en tu corazón. Tu oración se mantiene completamente confidencial y se trata con reverencia.",
    step2Title: "Elige Lugares Sagrados",
    step2Desc: "Selecciona entre los lugares más venerados de Jerusalén donde tu oración será entregada personalmente.",
    step3Title: "Recibe Confirmación",
    step3Desc: "Obtén una fotografía confirmando la entrega de tu oración en Tierra Santa.",
    sacredSites: "Lugares Sagrados",
    sacredSitesSubtitle: "Donde tus oraciones encuentran su hogar",
    viewAllSites: "Ver Todos los Lugares Sagrados",
    testimonials: "Testimonios",
    testimonialsSubtitle: "Historias de fe y oraciones respondidas",
    readMore: "Leer Más Testimonios",
    startJourney: "Comienza Tu Viaje de Oración Hoy",
    startJourneySubtitle: "Únete a miles que han encontrado paz a través de nuestro servicio sagrado de entrega de oraciones",
    submitPrayer: "Envía Tu Oración"
  },
  
  // Prayer Request page
  prayerRequest: {
    title: "Envía Tu Oración a los Lugares Santos de Jerusalén",
    subtitle: "Un viaje sagrado en cuatro simples pasos",
    step: "Paso",
    type: "Tipo",
    sites: "Lugares",
    prayer: "Oración",
    details: "Detalles",
    chooseType: "Elige Tu Tipo de Oración",
    oneTime: "Oración Única",
    oneTimeDesc: "Elige tus lugares sagrados y envía una sola oración",
    journey: "Viaje de Oración",
    journeyDesc: "Un viaje continuo de oración en tus lugares sagrados elegidos",
    choosePackage: "Elige Tu Paquete de Oración",
    holySite: "Lugar Santo",
    holySites: "Lugares Santos",
    mostPopular: "MÁS POPULAR",
    chooseSites: "Elige Tus Lugares Sagrados",
    chooseSitesDesc: "Selecciona uno o más lugares santos donde se entregará tu oración",
    selectAll: "Seleccionar Todo",
    clear: "Limpiar",
    writePrayer: "Escribe Tu Oración",
    writePrayerDesc: "Comparte tu oración sincera. Se mantendrá privada y se tratará con reverencia.",
    prayerPlaceholder: "Escribe tu oración aquí...",
    characters: "caracteres",
    minRequired: "Mínimo 50 requeridos",
    prayerLibrary: "Biblioteca de Oraciones",
    yourDetails: "Tus Datos",
    yourDetailsDesc: "Enviaremos la confirmación de tu oración a este correo",
    dedicatedTo: "Esta Oración Está Dedicada a",
    dedicatedPlaceholder: "Ingresa nombre(s)",
    yourName: "Tu Nombre",
    namePlaceholder: "Ingresa tu nombre",
    yourEmail: "Tu Correo",
    emailPlaceholder: "Ingresa tu correo",
    reviewRequest: "Revisa Tu Solicitud de Oración",
    prayerType: "Tipo de Oración",
    sacredSites: "Lugares Sagrados",
    selected: "seleccionados",
    prayerLength: "Longitud de la Oración",
    back: "Atrás",
    previous: "Anterior",
    next: "Siguiente",
    continue: "Continuar",
    submit: "Enviar",
    submitPrayer: "Enviar Oración",
    submitting: "Enviando..."
  },
  
  // Checkout
  checkout: {
    backToPricing: "Volver a Precios",
    orderSummary: "Resumen del Pedido",
    billedMonthly: "Facturado mensualmente",
    billedAnnually: "Facturado anualmente",
    total: "Total",
    chargedMonthly: "Cobrado mensualmente hasta cancelar",
    chargedAnnually: "Cobrado anualmente hasta cancelar",
    secureCheckout: "Pago Seguro",
    securePayment: "Tu pago es procesado de forma segura por Stripe. Nunca almacenamos los datos de tu tarjeta.",
    features: {
      photos: "Fotos de alta calidad",
      delivery: "Entrega personal a lugares santos",
      confirmation: "Confirmación por correo con coordenadas GPS",
      cancel: "Cancela en cualquier momento, sin cargos"
    },
    contactInfo: "Información de Contacto",
    emailAddress: "Correo Electrónico",
    emailPlaceholder: "tu@ejemplo.com",
    emailHelper: "Enviaremos tu confirmación y recibo aquí",
    stripeRedirect: "Después de hacer clic en el botón de abajo, serás redirigido a la página de pago seguro de Stripe para completar tu compra.",
    agreeTerms: "Acepto los",
    termsOfService: "Términos de Servicio",
    and: "y",
    privacyPolicy: "Política de Privacidad",
    subscriptionNote: "Entiendo que esta es una suscripción recurrente que se renovará automáticamente hasta que cancele.",
    pay: "Pagar",
    continueToPay: "Continuar al Pago",
    processing: "Procesando...",
    redirecting: "Redirigiendo al pago...",
    secureStripe: "Tu pago está asegurado por Stripe con encriptación SSL de 256 bits",
    moneyBack: "Garantía de Devolución de 7 Días",
    moneyBackDesc: "Si no estás completamente satisfecho con nuestro servicio de entrega de oraciones dentro de 7 días, te reembolsaremos el pago completo, sin preguntas. Tu paz espiritual es nuestra prioridad."
  },
  
  // Footer
  footer: {
    stayConnected: "Mantente Conectado con Jerusalén",
    newsletterDesc: "Recibe reflexiones espirituales y actualizaciones de los lugares sagrados",
    emailPlaceholder: "Ingresa tu correo",
    subscribe: "Suscribirse",
    subscribed: "¡Gracias por suscribirte!",
    quickLinks: "Enlaces Rápidos",
    resources: "Recursos",
    connectWithUs: "Conéctate con Nosotros",
    followUs: "Síguenos para bendiciones diarias e inspiración de Tierra Santa.",
    copyright: "© 2025 Jerusalem Holy Prayer. Todos los derechos reservados.",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio"
  },
  
  // Auth
  auth: {
    welcomeBack: "Bienvenido de Nuevo",
    signIn: "Inicia sesión en tu cuenta",
    email: "Correo",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    login: "Iniciar Sesión",
    loggingIn: "Iniciando sesión...",
    noAccount: "¿No tienes cuenta?",
    signUp: "Regístrate",
    createAccount: "Crear Cuenta",
    joinUs: "Únete a nuestra comunidad de creyentes",
    name: "Nombre Completo",
    confirmPassword: "Confirmar Contraseña",
    creating: "Creando cuenta...",
    hasAccount: "¿Ya tienes cuenta?",
    passwordRequirement: "Al menos 6 caracteres"
  },
  
  // Common
  common: {
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    close: "Cerrar",
    search: "Buscar",
    filter: "Filtrar",
    all: "Todo",
    learnMore: "Saber Más"
  },

  // Pricing page
  pricing: {
    title: "Precios Simples y Transparentes",
    subtitle: "Elige el viaje sagrado que resuene con tu corazón",
    oneTime: "Oración Única",
    oneTimeDesc: "Perfecto para intenciones y ocasiones especiales",
    subscription: "Viaje de Oración",
    subscriptionDesc: "Conexión espiritual continua con Tierra Santa",
    holySite: "Lugar Santo",
    holySites: "Lugares Santos",
    popular: "MÁS POPULAR",
    perMonth: "/mes",
    perYear: "/año",
    billedAnnually: "facturado anualmente",
    monthly: "Mensual",
    annual: "Anual",
    savePercent: "Ahorra 17%",
    selectPlan: "Seleccionar Plan",
    getStarted: "Comenzar",
    features: "Características",
    includes: "Incluye",
    chooseThis: "Elegir Este Plan"
  },

  // Sacred Sites page
  sacredSites: {
    title: "Lugares Sagrados de Jerusalén",
    subtitle: "Descubre los lugares santos donde se entregarán tus oraciones",
    exploreAll: "Explorar Todos los Sitios",
    viewDetails: "Ver Detalles"
  },

  // Prayer Wall page
  prayerWall: {
    title: "Muro de Oración",
    subtitle: "Únete a nuestra comunidad en oración. Lee e inspírate con las oraciones de otros creyentes.",
    recentPrayers: "Oraciones Recientes",
    anonymous: "Anónimo",
    prayedAt: "Oró en"
  },

  // Testimonials page
  testimonials: {
    title: "Historias de Fe",
    subtitle: "Lee cómo Jerusalem Holy Prayer ha tocado vidas alrededor del mundo",
    readMore: "Leer Más",
    verifiedPurchase: "Compra Verificada"
  },

  // Contact page
  contact: {
    title: "Contáctanos",
    subtitle: "Nos encantaría saber de ti. Envíanos un mensaje y te responderemos lo antes posible.",
    name: "Tu Nombre",
    email: "Tu Correo",
    subject: "Asunto",
    message: "Mensaje",
    send: "Enviar Mensaje",
    sending: "Enviando...",
    address: "Dirección",
    phone: "Teléfono",
    emailUs: "Escríbenos",
    successTitle: "Mensaje Enviado",
    successDesc: "Te responderemos pronto."
  },

  // FAQ page
  faq: {
    title: "Preguntas Frecuentes",
    subtitle: "Encuentra respuestas a preguntas comunes sobre nuestro servicio de entrega de oraciones"
  },

  // About page
  about: {
    title: "Sobre Nosotros",
    subtitle: "Nuestra misión es conectar corazones con Tierra Santa",
    ourStory: "Nuestra Historia",
    ourTeam: "Nuestro Equipo en Jerusalén"
  },

  // Dashboard
  dashboard: {
    title: "Mi Panel",
    welcome: "Bienvenido de nuevo",
    myPrayers: "Mis Oraciones",
    myPayments: "Mis Pagos",
    noPrayers: "Sin oraciones aún",
    noPayments: "Sin pagos aún",
    viewAll: "Ver Todo",
    status: "Estado",
    date: "Fecha",
    amount: "Monto"
  },

  // Checkout Success
  checkoutSuccess: {
    title: "¡Pago Exitoso!",
    subtitle: "Gracias por tu pedido. Tu viaje de oración comienza ahora.",
    orderNumber: "Número de Orden",
    emailSent: "Se ha enviado un correo de confirmación a",
    whatNext: "¿Qué sigue?",
    step1: "Nuestro equipo recibe tu solicitud de oración",
    step2: "Entregamos personalmente tu oración a los lugares sagrados",
    step3: "Recibes fotos y confirmación por correo",
    returnHome: "Volver al Inicio",
    viewDashboard: "Ver Panel"
  },

  // About page extended
  aboutPage: {
    ourStory: "Nuestra Historia",
    ourStoryP1: "Jerusalem Holy Prayer nació de una simple conversación en 2019 entre tres amigos sentados en un café cerca de la Puerta de Jaffa. Rachel, una guía turística que había pasado quince años guiando peregrinos cristianos por Tierra Santa, compartió su angustia por las innumerables personas que conoció que soñaban con visitar Jerusalén pero no podían—por problemas de salud, limitaciones financieras, obligaciones familiares o edad.",
    ourStoryP2: "\"Tantas personas lloran cuando me dicen que nunca verán estos lugares en persona\", dijo. \"¿Y si pudiéramos traer sus oraciones aquí?\" Esa pregunta desencadenó todo lo que siguió.",
    ourStoryP3: "Los tres fundadores—Rachel, David (un teólogo cristiano y residente de larga data en Jerusalén), y Sarah (una fotógrafa que documenta lugares santos)—comenzaron pequeño. Ofrecieron entregar oraciones para amigos y familiares en el extranjero. La voz se corrió a través de iglesias, grupos de oración y comunidades de fe. Lo que comenzó como un puñado de oraciones escritas a mano llevadas al Muro Occidental creció hasta convertirse en una misión que sirve a miles de creyentes en todo el mundo.",
    ourStoryP4: "Hoy, nuestro equipo ha crecido para incluir a doce individuos dedicados, todos residentes de Jerusalén con profundas conexiones con la geografía sagrada de la ciudad. Algunos son israelíes nativos, otros han hecho aliyah desde varios países, trayendo diversas tradiciones cristianas—católica, ortodoxa, protestante y más. Lo que nos une es una profunda reverencia por el significado espiritual de Jerusalén y un compromiso de servir a aquellos que buscan conectarse con estos lugares santos.",
    ourStoryP5: "Navegamos las antiguas piedras de la Ciudad Vieja diariamente, manteniendo relaciones con guardianes y custodios de los sitios que entienden nuestra misión. Hemos aprendido los ritmos de cada lugar—cuándo la Iglesia del Santo Sepulcro está más tranquila para la contemplación, qué días ofrecen el mejor acceso a la Tumba del Jardín, cómo programar las entregas para evitar interrumpir los servicios de adoración y grupos de peregrinos.",
    ourStoryP6: "Desde nuestra fundación, hemos entregado más de 50,000 oraciones a los lugares sagrados de Jerusalén. Cada una representa las esperanzas más profundas, miedos, gratitud o peticiones de una persona. Hemos llevado oraciones de sanación durante enfermedades, de guía durante transiciones de vida, de reconciliación en relaciones rotas, de fortaleza durante el duelo, y de acción de gracias durante la alegría. El privilegio de este trabajo nos humilla diariamente.",
    ourStoryP7: "Creemos que la fe trasciende la geografía, pero hay algo poderoso en la presencia física en lugares santificados por siglos de oración y devoción. A través de nuestro servicio, ayudamos a tender puentes entre los corazones que anhelan conexión y las antiguas piedras que han sido testigos del viaje espiritual de la humanidad durante milenios.",
    ourValues: "Nuestros Valores Fundamentales",
    valueReverence: "Reverencia",
    valueReverenceDesc: "Cada oración es manejada con el más profundo respeto y cuidado espiritual",
    valueCommunity: "Comunidad",
    valueCommunityDesc: "Conectando creyentes de todo el mundo a través de la fe y la oración compartidas",
    valueAccessibility: "Accesibilidad",
    valueAccessibilityDesc: "Haciendo Tierra Santa accesible para todos, en todas partes",
    valueAuthenticity: "Autenticidad",
    valueAuthenticityDesc: "Experiencias espirituales genuinas arraigadas en antiguas tradiciones sagradas",
    ourTeamTitle: "Nuestro Equipo en Jerusalén",
    ourTeamP1: "Nuestro equipo consiste en doce individuos que llaman hogar a Jerusalén—no turistas o residentes temporales, sino personas profundamente arraigadas en esta antigua ciudad. La mayoría ha vivido aquí por diez años o más; algunos nacieron dentro de las murallas de la Ciudad Vieja. Este no es solo nuestro lugar de trabajo; es donde adoramos, criamos a nuestras familias y experimentamos la vida diaria entre sitios que dieron forma al paisaje espiritual de la civilización occidental.",
    ourTeamP2: "Cada miembro del equipo aporta fortalezas únicas. Rachel y David, nuestros cofundadores, supervisan las operaciones y mantienen relaciones con los custodios de los sitios. Sarah lidera nuestro equipo de documentación, asegurando que cada fotografía capture auténticamente el momento de la entrega de la oración.",
    ourTeamP3: "Otros manejan la logística—Miriam coordina horarios según el acceso a los sitios y las observancias religiosas; Benjamin gestiona nuestras comunicaciones multilingües; Leah y Thomas entregan oraciones a sitios en toda la ciudad. Todos reciben capacitación en protocolos respetuosos de los sitios, documentación fotográfica y manejo de oraciones con la reverencia que merecen.",
    ourTeamP4: "No somos una organización grande, y lo preferimos así. Esto nos permite mantener un toque personal y un cuidado genuino por cada oración que manejamos. Muchos de nosotros intercambiamos correos electrónicos con usuarios regulares, construyendo relaciones que van más allá de transacciones individuales. Cuando entregamos una oración para alguien que lucha contra una enfermedad o celebra un hito, llevamos su historia con nosotros a los lugares santos.",
    ourTeamP5: "Vivir en Jerusalén significa navegar realidades complejas—tensiones políticas, preocupaciones de seguridad y los desafíos diarios de una ciudad dividida. Sin embargo, estamos convencidos de que este trabajo importa. En un mundo a menudo marcado por la división, facilitamos conexiones arraigadas en la fe, la esperanza y la humanidad compartida. Cada oración que entregamos es un acto de construcción de puentes, un pequeño gesto hacia la paz que el nombre de Jerusalén promete."
  },

  // FAQ page extended
  faqPage: {
    stillHaveQuestions: "¿Aún Tienes Preguntas?",
    stillHaveQuestionsDesc: "Nuestro equipo está aquí para ayudar. No dudes en contactarnos en cualquier momento.",
    contactUs: "Contáctanos"
  },

  // Terms page
  termsPage: {
    title: "Términos de Servicio",
    lastUpdated: "Última Actualización: Enero 2025",
    agreementTitle: "Acuerdo de Términos",
    agreementText: "Al acceder y utilizar los servicios de Jerusalem Holy Prayer, aceptas estar sujeto a estos Términos de Servicio. Si no estás de acuerdo con alguna parte de estos términos, no puedes usar nuestros servicios.",
    servicesTitle: "Nuestros Servicios",
    servicesIntro: "Jerusalem Holy Prayer proporciona un servicio de entrega de oraciones donde:",
    servicesItem1: "Los usuarios envían oraciones a través de nuestro sitio web",
    servicesItem2: "Nuestro equipo con sede en Jerusalén entrega estas oraciones a los lugares santos seleccionados",
    servicesItem3: "Los usuarios reciben confirmación fotográfica de entrega",
    servicesItem4: "Las opciones de suscripción proporcionan servicios continuos de entrega de oraciones",
    responsibilitiesTitle: "Responsabilidades del Usuario",
    responsibilitiesIntro: "Al usar nuestro servicio, aceptas:",
    responsibilitiesItem1: "Proporcionar información precisa y completa",
    responsibilitiesItem2: "Enviar oraciones que sean respetuosas y apropiadas",
    responsibilitiesItem3: "No usar el servicio para fines ilegales",
    responsibilitiesItem4: "Respetar la naturaleza sagrada de los sitios donde se entregan las oraciones",
    responsibilitiesItem5: "No compartir ni revender el acceso a tu cuenta",
    contentTitle: "Directrices de Contenido",
    contentIntro: "Todas las oraciones enviadas deben ser:",
    contentItem1: "Respetuosas y apropiadas para entornos sagrados",
    contentItem2: "Libres de discurso de odio, violencia o contenido discriminatorio",
    contentItem3: "Sin promoción de actividades ilegales",
    contentItem4: "Expresiones espirituales sinceras",
    contentNote: "Nos reservamos el derecho de rechazar el servicio para oraciones que violen estas directrices.",
    paymentTitle: "Pago y Suscripciones",
    paymentOneTime: "Oraciones Únicas: El pago se requiere al momento del envío.",
    paymentSubscriptions: "Suscripciones:",
    paymentItem1: "Facturadas mensual o anualmente según se seleccione",
    paymentItem2: "Renovadas automáticamente a menos que se cancelen",
    paymentItem3: "Pueden cancelarse en cualquier momento a través de tu cuenta",
    paymentItem4: "La cancelación tiene efecto al final del período de facturación actual",
    paymentItem5: "Sin reembolsos por meses parciales",
    refundTitle: "Política de Reembolso",
    refundItem1: "Se pueden solicitar reembolsos dentro de los 7 días de la entrega de la oración si el servicio no fue proporcionado como se describió",
    refundItem2: "Sin reembolsos después de que la oración haya sido entregada y confirmada",
    refundItem3: "Los reembolsos de suscripción no están disponibles para porciones no utilizadas del período de suscripción",
    refundItem4: "Todas las solicitudes de reembolso deben enviarse por escrito a nuestro equipo de soporte",
    availabilityTitle: "Disponibilidad del Servicio",
    availabilityIntro: "Aunque nos esforzamos por entregar todas las oraciones dentro del plazo prometido, no podemos garantizar la disponibilidad del servicio durante:",
    availabilityItem1: "Feriados religiosos importantes cuando los sitios pueden estar cerrados o restringidos",
    availabilityItem2: "Situaciones de seguridad en Jerusalén",
    availabilityItem3: "Desastres naturales o emergencias",
    availabilityItem4: "Problemas técnicos fuera de nuestro control",
    availabilityNote: "En tales casos, te notificaremos y reprogramaremos u ofreceremos un reembolso.",
    intellectualTitle: "Propiedad Intelectual",
    intellectualText: "Todo el contenido en este sitio web, incluyendo texto, gráficos, logotipos y fotografías, es propiedad de Jerusalem Holy Prayer y está protegido por las leyes de derechos de autor. No puedes reproducir, distribuir o crear obras derivadas sin nuestro permiso por escrito.",
    liabilityTitle: "Limitación de Responsabilidad",
    liabilityText: "Jerusalem Holy Prayer proporciona este servicio como una ofrenda espiritual. No garantizamos resultados específicos de la oración. Nuestra responsabilidad se limita al monto pagado por el servicio. No somos responsables de ningún daño indirecto, incidental o consecuente.",
    modificationsTitle: "Modificaciones al Servicio",
    modificationsText: "Nos reservamos el derecho de modificar, suspender o discontinuar cualquier parte de nuestro servicio en cualquier momento. Proporcionaremos aviso de cambios significativos cuando sea posible.",
    governingTitle: "Ley Aplicable",
    governingText: "Estos Términos de Servicio se rigen por las leyes del Estado de Israel. Cualquier disputa se resolverá en los tribunales de Jerusalén.",
    contactTitle: "Información de Contacto",
    contactText: "Para preguntas sobre estos Términos de Servicio, contáctanos en:"
  },

  // Privacy page
  privacyPage: {
    title: "Política de Privacidad",
    lastUpdated: "Última Actualización: Enero 2025",
    introTitle: "Introducción",
    introText: "En Jerusalem Holy Prayer, tomamos tu privacidad en serio. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información personal cuando usas nuestro servicio de entrega de oraciones.",
    collectTitle: "Información que Recopilamos",
    personalInfo: "Información Personal:",
    personalItem1: "Nombre e información de contacto (dirección de correo electrónico)",
    personalItem2: "Texto de oración e información de dedicatoria",
    personalItem3: "Información de pago (procesada de forma segura a través de proveedores externos)",
    personalItem4: "Correspondencia con nuestro equipo de soporte",
    autoInfo: "Información Recopilada Automáticamente:",
    autoItem1: "Tipo de navegador e información del dispositivo",
    autoItem2: "Dirección IP y datos de ubicación",
    autoItem3: "Estadísticas de uso del sitio web",
    useTitle: "Cómo Usamos tu Información",
    useItem1: "Para entregar tus oraciones a los lugares sagrados seleccionados",
    useItem2: "Para enviarte correos de confirmación y fotos de entrega",
    useItem3: "Para procesar pagos de forma segura",
    useItem4: "Para mejorar nuestros servicios y experiencia del usuario",
    useItem5: "Para comunicarnos contigo sobre tus solicitudes",
    useItem6: "Para enviar boletines (solo con tu consentimiento)",
    confidentialityTitle: "Confidencialidad de las Oraciones",
    confidentialityText: "Tus oraciones son tratadas con la máxima reverencia y confidencialidad. Son manejadas solo por los miembros de nuestro equipo de confianza con sede en Jerusalén y nunca se comparten, venden o usan para ningún propósito que no sea la entrega a los lugares santos que has seleccionado.",
    securityTitle: "Seguridad de Datos",
    securityText: "Implementamos medidas de seguridad estándar de la industria para proteger tu información personal. Esto incluye encriptación, servidores seguros y acceso restringido a datos sensibles. Sin embargo, ningún método de transmisión por internet es 100% seguro, y no podemos garantizar seguridad absoluta.",
    thirdPartyTitle: "Servicios de Terceros",
    thirdPartyIntro: "Usamos servicios de terceros confiables para:",
    thirdPartyItem1: "Procesamiento de pagos (tu información de pago es manejada de forma segura por nuestro proveedor de pagos)",
    thirdPartyItem2: "Servicios de entrega de correo electrónico",
    thirdPartyItem3: "Análisis del sitio web",
    thirdPartyNote: "Estos servicios tienen sus propias políticas de privacidad, y te animamos a revisarlas.",
    rightsTitle: "Tus Derechos",
    rightsIntro: "Tienes derecho a:",
    rightsItem1: "Acceder a tu información personal",
    rightsItem2: "Solicitar corrección de datos inexactos",
    rightsItem3: "Solicitar eliminación de tu información",
    rightsItem4: "Optar por no recibir comunicaciones de marketing",
    rightsItem5: "Retirar el consentimiento para el procesamiento de datos",
    cookiesTitle: "Cookies",
    cookiesText: "Usamos cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio web. Puedes controlar la configuración de cookies a través de las preferencias de tu navegador.",
    changesTitle: "Cambios a Esta Política",
    changesText: "Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos sobre cualquier cambio significativo publicando la nueva política en esta página y actualizando la fecha de \"Última Actualización\".",
    contactTitle: "Contáctanos",
    contactText: "Si tienes alguna pregunta sobre esta Política de Privacidad o nuestras prácticas de datos, contáctanos en:"
  },

  // Dashboard extended
  dashboardPage: {
    memberSince: "Miembro desde",
    totalPrayers: "Total de Oraciones",
    totalPayments: "Total de Pagos",
    newPrayerRequest: "Nueva Solicitud de Oración",
    myPrayers: "Mis Oraciones",
    paymentHistory: "Historial de Pagos",
    noPrayersYet: "Sin oraciones aún",
    noPrayersDesc: "Comienza tu viaje espiritual enviando tu primera oración",
    submitFirstPrayer: "Envía Tu Primera Oración",
    noPaymentsYet: "Sin pagos aún",
    noPaymentsDesc: "Tu historial de pagos aparecerá aquí",
    viewPricingPlans: "Ver Planes de Precios",
    oneTime: "Única",
    journey: "Viaje",
    dedicatedTo: "Dedicada a:",
    holySitesSelected: "lugar(es) santo(s) seleccionado(s)"
  },

  // Admin Dashboard
  adminPage: {
    title: "Panel de Administración",
    subtitle: "Gestiona oraciones, contactos y usuarios",
    refresh: "Actualizar",
    totalUsers: "Total de Usuarios",
    prayerRequests: "Solicitudes de Oración",
    pending: "pendientes",
    contactMessages: "Mensajes de Contacto",
    new: "nuevos",
    totalRevenue: "Ingresos Totales",
    payments: "pagos",
    tabs: {
      prayers: "Solicitudes de Oración",
      contacts: "Mensajes de Contacto",
      users: "Usuarios",
      payments: "Pagos"
    },
    table: {
      status: "Estado",
      from: "De",
      dedicatedTo: "Dedicada A",
      sites: "Sitios",
      date: "Fecha",
      actions: "Acciones",
      customer: "Cliente",
      amount: "Monto",
      type: "Tipo",
      user: "Usuario",
      email: "Correo",
      role: "Rol",
      joined: "Registrado"
    },
    actions: {
      process: "Procesar",
      deliver: "Entregar",
      markRead: "Marcar Leído",
      markResponded: "Marcar Respondido",
      makeAdmin: "Hacer Admin",
      removeAdmin: "Quitar Admin"
    },
    empty: {
      noPrayers: "Sin solicitudes de oración aún",
      noContacts: "Sin mensajes de contacto aún",
      noUsers: "Sin usuarios aún",
      noPayments: "Sin pagos aún"
    },
    roles: {
      admin: "Admin",
      user: "Usuario"
    }
  },

  // Contact page extended
  contactPage: {
    beforeReachOut: "Antes de Contactarnos",
    forFasterAssistance: "Para asistencia más rápida, verifica si tu pregunta está respondida en nuestro:",
    faqLink: "Página de Preguntas Frecuentes",
    faqDesc: "- Cubre las preguntas más comunes sobre nuestro servicio",
    aboutLink: "Sobre Nosotros",
    aboutDesc: "- Conoce a nuestro equipo y misión",
    termsLink: "Términos de Servicio",
    termsDesc: "- Políticas de reembolso, suscripciones y detalles del servicio",
    technicalNote: "Si estás experimentando un problema técnico con el sitio web, incluye detalles sobre tu navegador, dispositivo y el mensaje de error específico que estás viendo.",
    callUs: "Llámanos",
    jerusalemOffice: "Oficina de Jerusalén:",
    usSupportLine: "Línea de Soporte EE.UU.:",
    officeHours: "Jerusalén: Dom-Jue 9AM-5PM (IST)",
    usHours: "Línea EE.UU.: Lun-Vie 9AM-6PM (EST)",
    officeLocation: "Ubicación de la Oficina",
    officeAddress1: "Jerusalem Holy Prayer",
    officeAddress2: "Barrio Cristiano",
    officeAddress3: "Ciudad Vieja, Jerusalén 91140",
    officeNote: "Cerca de la Puerta de Jaffa",
    officeVisit: "Visitas presenciales solo con cita",
    responseTimes: "Tiempos de Respuesta",
    responseEmail: "Consultas por correo: Dentro de 24 horas (días hábiles)",
    responsePrayer: "Soporte de oración: Mismo día o siguiente día hábil",
    responsePhone: "Llamadas telefónicas: Inmediatas durante horario laboral",
    responseUrgent: "Solicitudes de oración urgentes: Respuesta prioritaria dentro de 4 horas",
    formIntro: "Ya sea que tengas preguntas sobre nuestro servicio, necesites ayuda con una solicitud de oración, o quieras compartir tu experiencia, estamos aquí para escuchar. Nuestro equipo generalmente responde dentro de 24 horas durante días hábiles.",
    generalInquiries: "Consultas Generales:",
    prayerSupport: "Soporte de Oración:",
    technicalSupport: "Soporte Técnico:"
  },

  // Sacred Sites extended
  sacredSitesPage: {
    heroSubtitle: "Descubre los lugares santos donde tus oraciones serán entregadas con reverencia y cuidado",
    allSites: "Todos los Sitios",
    sendPrayerHere: "Enviar una Oración Aquí"
  },

  // Header mobile menu
  mobileMenu: {
    adminPanel: "Panel de Admin",
    signOut: "Cerrar Sesión"
  }
};

export default es;
